import { useWatch } from 'react-hook-form';
import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface RateTabProps {
  formMode: FormMode;
}

export const RateTab: React.FC<RateTabProps> = ({ formMode }) => {
  const type = useWatch({ name: 'ma_ngv', defaultValue: '1' });

  return (
    <div className='space-y-2 p-3'>
      <div className='flex flex-col gap-3 space-y-1'>
        <div className='flex items-center'>
          <Label className='w-48 min-w-48'>Sửa tỷ giá ghi sổ</Label>
          <div className='w-[250px]'>
            <FormField type='checkbox' name='tg_dd' disabled={formMode === 'view' || type !== '1'} />
          </div>
        </div>

        {type !== '1' && (
          <div className='flex items-center'>
            <Label className='w-48 min-w-48'>Tạo chênh lệch tỷ giá ngay</Label>
            <div className='w-[250px]'>
              <FormField type='checkbox' name='cltg_yn' disabled={formMode === 'view'} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
